import { createSlotRecipe } from './runtime';

const topbarConfig = {"name":"topbar","slots":["root","start","crumbs","crumb","separator","end","chip"]}

export const topbar = /* @__PURE__ */ createSlotRecipe(topbarConfig)